import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const { loginWithApple, loginWithGoogle, isLoading } = useAuth();

  const handleAppleLogin = async () => {
    try {
      await loginWithApple();
    } catch (error) {
      console.error('Apple login failed:', error);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await loginWithGoogle();
    } catch (error) {
      console.error('Google login failed:', error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">BudgetApp</h1>
        <p className="login-subtitle">Välkommen! Logga in för att fortsätta</p>

        <div className="login-buttons">
          <button
            className="login-button apple-button"
            onClick={handleAppleLogin}
            disabled={isLoading}
          >
            {isLoading ? (
              <span>Loggar in...</span>
            ) : (
              <>
                
                <span>Fortsätt med Apple</span>
              </>
            )}
          </button>

          <button
            className="login-button google-button"
            onClick={handleGoogleLogin}
            disabled={isLoading}
          >
            {isLoading ? (
              <span>Loggar in...</span>
            ) : (
              <>
                
                <span>Fortsätt med Google</span>
              </>
            )}
          </button>
        </div>

        {isLoading && (
          <p className="loading-text">Omdirigerar till inloggning...</p>
        )}
      </div>
    </div>
  );
};

export default LoginPage;